import { createRoot } from 'react-dom/client';
import { SceneProvider } from './presentation/providers/SceneProvider';
import { App } from './presentation/App';

const params = new URLSearchParams(window.location.search);

export const CONFIG = {
  maxFrameCacheMb: Number(params.get('MAX_FRAME_CACHE_MB') ?? 512),
  pointSize: Number(params.get('pointSize') ?? 1),
  debugCache: params.get('debug') === 'cache',
  debugStats: params.get('debug') === 'stats',
  camX: Number(params.get('camX') ?? process.env.DEFAULT_CAM_X ?? -70),
  camY: Number(params.get('camY') ?? process.env.DEFAULT_CAM_Y ?? -58),
  camZ: Number(params.get('camZ') ?? process.env.DEFAULT_CAM_Z ?? 80),
  targetX: Number(params.get('targetX') ?? process.env.DEFAULT_TARGET_X ?? -70),
  targetY: Number(params.get('targetY') ?? process.env.DEFAULT_TARGET_Y ?? -58),
  targetZ: Number(params.get('targetZ') ?? process.env.DEFAULT_TARGET_Z ?? 0),
} as const;

const root = createRoot(document.getElementById('root')!);

root.render(
  <SceneProvider maxCacheMb={CONFIG.maxFrameCacheMb} debug={CONFIG.debugCache}>
    <App />
  </SceneProvider>
);
